<template>
  <div :class="{ 'ful-section': !bare }" v-if="orderInfo">
    <div :class="{ 'ful-inner-section-heading': bare }" v-if="showHeading">
      <svg v-if="bare" class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
      <h2 class="ful-section-title" v-if="bare && showHeading">配送订单信息</h2>
    </div>
    <div :class="{ 'ful-info-grid': bare }">
      <div><span class="ful-info-label">形态：</span><span class="ful-info-value">{{ orderInfo.formText }}</span></div>
      <div><span class="ful-info-label">数量：</span><span class="ful-info-value">{{ orderInfo.formCount }}</span></div>

      <!-- 额外字段 -->
      <div v-if="hasValue(orderInfo.quantityDispensed)"><span class="ful-info-label">每副调配数量：</span><span class="ful-info-value">{{ orderInfo.quantityDispensed }}</span></div>
      <div v-if="hasValue(orderInfo.dosage)"><span class="ful-info-label">服用次数及计量：</span><span class="ful-info-value">{{ orderInfo.dosage }}</span></div>
      <div v-if="hasValue(orderInfo.prescriptionWithShipment)"><span class="ful-info-label">处方笺寄送：</span><span class="ful-info-value">{{ orderInfo.prescriptionWithShipment }}</span></div>

      <div><span class="ful-info-label">下单时间：</span><span class="ful-info-value">{{ orderInfo.createTime }}</span></div>
      <div v-if="orderInfo.status >= 1 && orderInfo.payTime"><span class="ful-info-label">付款时间：</span><span class="ful-info-value">{{ orderInfo.payTime }}</span></div>
      <div><span class="ful-info-label">配送中心：</span><span class="ful-info-value">{{ orderInfo.deliveryName }}</span></div>
    </div>

    <!-- 配送订单编号 -->
    <div class="ful-order-id-tag" v-if="bare && orderInfo.deliveryOrderId">
      <b>配送订单编号</b>{{ orderInfo.deliveryOrderId }}
    </div>

    <!-- 备注 + 金额 -->
    <div v-if="orderInfo.remark != null && orderInfo.remark.length != 0 || orderInfo.status != 0" style="margin-top:16px">
      <div v-if="orderInfo.remark != null && orderInfo.remark.length != 0" style="font-size:14px;color:#64748b;margin-bottom:8px">
        <span class="ful-info-label">备注：</span><span class="ful-info-value">{{ orderInfo.remark }}</span>
      </div>
      <div v-if="orderInfo.status != 0" style="text-align:right">
        <span class="ful-info-label">支付金额：</span>
        <span style="color:#d35845;font-weight:700;font-size:20px">¥ {{ orderInfo.sumPrice }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderDetailInfo',
  props: {
    orderInfo: { type: Object, required: true },
    bare: { type: Boolean, default: false },
    showHeading: { type: Boolean, default: true }
  },
  methods: {
    hasValue(value) {
      if (value === undefined || value === null) return false
      const str = String(value).trim()
      if (str.length === 0) return false
      // 去除常见分隔符/空白/标点后还有内容才算有效值
      const meaningful = str.replace(/[;\s,，、。:：|｜\\/]+/g, '')
      return meaningful.length > 0
    }
  }
}
</script>
